(ns rothko.theme.manatee.form2.validation-message
  (:refer-clojure :exclude [rem +])
  (:require [garden.units :refer [rem]]
            [rothko.styles.vars.basic :refer [font-sizes]]
            [rothko.theme.manatee.colours :refer [colours]]))

(def messages-min-height (rem 2))

(def validation-message
  {:error
   {:message-color (:red-dark colours)
    :message-font-size (:small font-sizes)
    :messages-min-height messages-min-height}})
